import React, { useState, useEffect } from "react";
import TopBar from "../HTML/TopBar";
import Header from "../HTML/Header";
import Footer from "../HTML/Footer";
import NewsletterSection from "../../pages/aboutus/newsletter-section/NewsletterSection";
import "../CSS/Layout.css";

const Layout = ({ children }) => {
  const [showTopBar, setShowTopBar] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowTopBar(false);
      } else {
        setShowTopBar(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="layout-container">
      {showTopBar && <TopBar />}
      <Header />
      <main>{children}</main>
      <NewsletterSection />
      <Footer />  {/* Always at the bottom */}
    </div>
  );
};

export default Layout;